import React from 'react';
import './styles/Contact.css';

const Contact = () => {
    return (
        <section id="contact" className="contact-section">
            <div className="contact-content">
                <h3>Get in Touch</h3>
                <h2>Contact Me</h2>
                <div className="contact-links">
                    <a href="mailto:yassinemili1@outlook.com" className="contact-item">
                        <span className="icon">✉</span>
                        yassinemili1@outlook.com
                    </a>
                    <a href="tel:+21695550960" className="contact-item">
                        <span className="icon"><i className="fas fa-phone"></i></span>
                        +216 95 550 960
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Contact;
